import { defineMessages } from 'react-intl-next';

export const messages: {
	inspectViewTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	queryDetailsSidePanelComingSoon: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	exampleSecondTab: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	detailsTab: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	jsonTab: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	queryDetailsTab: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	inspectViewTitle: {
		id: 'organization.audit.log.side-panel.inspect-view.title',
		defaultMessage: 'Inspect view',
		description: 'Title for the audit log side panel inspect view',
	},
	queryDetailsSidePanelComingSoon: {
		id: 'organization.audit.log.side-panel.query-details.coming-soon',
		defaultMessage: 'Query Details Side Panel - Coming Soon',
		description: 'Message for the query details side panel coming soon',
	},
	exampleSecondTab: {
		id: 'organization.audit.log.side-panel.example-second-tab',
		defaultMessage: 'Example Second Tab',
		description: 'Example second tab label for query details mode',
	},
	detailsTab: {
		id: 'organization.audit.log.side-panel.tabs.details.tab',
		defaultMessage: 'Details',
		description: 'Title of the audit log side panel tab details',
	},
	jsonTab: {
		id: 'organization.audit.log.side-panel.tabs.json.tab',
		defaultMessage: 'JSON',
		description: 'Title of the audit log side panel tab json',
	},
	queryDetailsTab: {
		id: 'organization.audit.log.side-panel.tabs.query-details.tab',
		defaultMessage: 'Details',
		description: 'Title of the audit log side panel tab query details',
	},
});
